/* eslint-disable @typescript-eslint/member-ordering */
import { _decorator, CCInteger, ccenum } from 'cc';
import { DEV } from 'cc/env';
import VapVideoPlayContext from '../../Components/VAP/VapVideoPlayContext';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

export enum DefaultVapVideosEnum {
    default = 0,
}
ccenum(DefaultVapVideosEnum);
export enum DefaultVapsEnum {
    '<None>' = 0,
}
ccenum(DefaultVapsEnum);

@ccclass('VapVideoAction')
export default class VapVideoAction extends BaseAction {
    @property({ type: VapVideoPlayContext, displayName: DEV && 'Vap元件', tooltip: DEV && 'vap' })
    public get displayVapVideoPlayContext() {
        return this.vapVideoPlayContext;
    }
    public set displayVapVideoPlayContext(value: VapVideoPlayContext) {
        this.vapVideoPlayContext = value;
    }

    @property({
        displayName: DEV && 'Vap名稱',
        tooltip: DEV && 'Vap名稱(vapName)',
        serializable: true,
    })
    public readonly vapName: string = '';

    @property({
        type: CCInteger,
        displayName: DEV && '起始時間',
        tooltip: DEV && '動畫直接從多少毫秒開始 \n(預設:0, 接續動畫不適用)',
    })
    public readonly startTime: number = 0;

    @property({
        displayName: DEV && '共用 Vap 資源',
        tooltip: DEV && '是否為共用 Vap 資源',
    })
    public readonly isShared: boolean = false;

    @property({
        displayName: DEV && '循環播放',
        tooltip: DEV && '是否為循環播放(loop)',
    })
    public readonly isLoop: boolean = false;

    @property({
        displayName: DEV && '是否設置暫停',
        tooltip: DEV && '是否設置暫停',
    })
    public readonly setPaused: boolean = false;

    @property({
        displayName: DEV && '是否暫停',
        tooltip: DEV && '是否暫停動畫',
        visible(this: VapVideoAction) {
            return this.setPaused;
        },
    })
    public readonly paused: boolean = false;

    @property({
        visible: false,
        serializable: true,
    })
    public vapVideoPlayContext: VapVideoPlayContext = null;
}
